import * as React from 'react';
import { Switch } from 'react-router-dom';
import Applications from './page/Applications';
import Login from './page/Login';
import TMSLoginReason from './page/TMSLoginReason';
import AuthenticatedRoute from './lib/route/AuthenticatedRoute';
import UnauthenticatedRoute from './lib/route/UnauthenticatedRoute';

export const Routes = () => (
  <Switch>
    <AuthenticatedRoute exact path="/">
      <Applications />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/tmslogin">
      <TMSLoginReason />
    </AuthenticatedRoute>
    <UnauthenticatedRoute path="/login">
      <Login />
    </UnauthenticatedRoute>
  </Switch>
);
